/**
 * Delivery page hero — headline, copy, CTAs, live-review caption.
 */
import { Link } from "react-router-dom";
import { Truck, ArrowRight } from "lucide-react";

export default function DeliveryHero({ live }) {
    return (
        <section
            data-testid="delivery-hero"
            className="bg-zen-elevated text-zen-cream relative overflow-hidden"
        >
            <div
                className="absolute inset-0 bg-cover bg-center opacity-30"
                style={{
                    backgroundImage:
                        "url('https://customer-assets.emergentagent.com/job_store-visual-refresh/artifacts/np1ky1c1_ChatGPT%20Image%20May%2025%2C%202026%2C%2007_43_09%20PM.png')",
                }}
                aria-hidden="true"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-zen-elevated/30 via-zen-elevated/65 to-zen-elevated/95" />
            <div className="relative max-w-[1400px] mx-auto px-6 sm:px-10 py-12 sm:py-16">
                <p className="text-[11px] uppercase tracking-[0.3em] text-zen-olive-light mb-5 inline-flex items-center gap-2">
                    <Truck size={11} /> Same-day weed delivery
                </p>
                <h1
                    data-testid="delivery-h1"
                    className="font-serif font-light text-4xl sm:text-5xl lg:text-7xl leading-[1.02] tracking-tight max-w-4xl mb-8"
                >
                    Cannabis to your door,{" "}
                    <span className="italic text-zen-olive-light">within the hour.</span>
                </h1>
                <p className="text-base sm:text-lg max-w-2xl opacity-85 mb-9 leading-relaxed">
                    NY-licensed delivery across Queens, Nassau Long Island, and the
                    entire borough of Staten Island. Order online, ID at handoff,
                    cash or debit. Free delivery on every order, $100 minimum,
                    most local orders inside the hour.
                </p>
                <div className="flex flex-wrap gap-3">
                    <Link
                        to="/menu/queens-long-island"
                        data-testid="delivery-order-queens"
                        className="bg-zen-cream text-zen-ink px-7 py-3.5 text-[11px] uppercase tracking-[0.22em] font-medium hover:bg-zen-bg transition-colors inline-flex items-center gap-2"
                    >
                        Order from Queens & LI <ArrowRight size={13} />
                    </Link>
                    <Link
                        to="/menu/staten-island"
                        data-testid="delivery-order-si"
                        className="border border-zen-cream/60 text-zen-cream px-7 py-3.5 text-[11px] uppercase tracking-[0.22em] font-medium hover:bg-zen-cream hover:text-zen-ink transition-colors inline-flex items-center gap-2"
                    >
                        Order from Staten Island <ArrowRight size={13} />
                    </Link>
                </div>
                <p className="text-[10px] uppercase tracking-[0.25em] opacity-60 mt-8">
                    21+ · NY-licensed adult-use dispensary ·{" "}
                    {Number(live.rating).toFixed(1)}★ from{" "}
                    {Number(live.count || 0).toLocaleString()}+ Google reviews
                </p>
            </div>
        </section>
    );
}
